import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carlos', 'Ana', 'Laura', 'Pedro', 'Sofía', 'Diego', 'Valentina', 'Miguel', 'Lucía', 'Javier', 'Elena', 'Andrés', 'Camila'];
const CITIES = ['Bogotá, Colombia', 'Ciudad de México, México', 'Madrid, España', 'Buenos Aires, Argentina', 'Santiago, Chile', 'Lima, Perú', 'Barcelona, España', 'Medellín, Colombia', 'Guadalajara, México', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Valencia, España'];
export const PurchaseNotification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1)) + 8000 + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-16">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0,
      y: 50
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: 100,
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 right-4 z-50 max-w-sm w-full md:w-auto" data-id="element-17">
          <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-emerald-500 flex items-center gap-4" data-id="element-18">
            <div className="bg-emerald-100 p-2 rounded-full" data-id="element-19">
              <CheckCircle className="w-6 h-6 text-emerald-600" data-id="element-20" />
            </div>
            <div data-id="element-21">
              <p className="text-sm font-medium text-gray-900" data-id="element-22">
                <span className="font-bold" data-id="element-23">{currentData.name}</span> de{' '}
                {currentData.city}
              </p>
              <p className="text-xs text-gray-500" data-id="element-24">
                acaba de comprar el megapack digital
              </p>
              <p className="text-xs text-emerald-600 font-semibold mt-1" data-id="element-25">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};